/**
 * press-quotes.js — 首页媒体评价自动轮播(定时淡入淡出,非滚动驱动)。
 *
 * 行为:
 *   - 每 INTERVAL 自动切换到下一条;圆点可点击跳转并重置计时。
 *   - 鼠标悬停 / 聚焦内部元素时暂停,移出后恢复。
 *   - 仅在进入视口时自动播放(IntersectionObserver),离开即暂停,省资源。
 *   - prefers-reduced-motion:不自动轮播,保留圆点手动切换。
 *
 * 标记:[data-press-quotes] 容器 · .press-quotes__slide 幻灯片 · [data-press-quotes-dots] 圆点组。
 * 视觉(淡入淡出 / is-active)由 components.css 负责。
 */
(function () {
  const INTERVAL = 5500;

  function initStage(stage) {
    if (stage.dataset.pressQuotesReady === '1') return;
    stage.dataset.pressQuotesReady = '1';
    const slides = Array.from(stage.querySelectorAll('.press-quotes__slide'));
    const dots = Array.from(stage.querySelectorAll('[data-press-quotes-dots] .press-quotes__dot'));
    if (slides.length < 2) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer = null;
    let inView = false;
    let hovered = false;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => {
        const on = i === index;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function play() {
      if (reduce || timer || !inView || hovered) return;
      timer = setInterval(() => show(index + 1), INTERVAL);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        show(i);
        stop();
        play();
      });
    });

    stage.addEventListener('mouseenter', () => { hovered = true; stop(); });
    stage.addEventListener('mouseleave', () => { hovered = false; play(); });
    stage.addEventListener('focusin', () => { hovered = true; stop(); });
    stage.addEventListener('focusout', () => { hovered = false; play(); });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            inView = e.isIntersecting;
            if (inView) play();
            else stop();
          });
        },
        { threshold: 0.35 }
      );
      io.observe(stage);
    } else {
      inView = true;
      play();
    }
  }

  function init() {
    document.querySelectorAll('[data-press-quotes]').forEach(initStage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
